import React, { useState } from 'react';
import { useLocation, NavLink } from 'react-router-dom';
import './MenuButton.scss';

const MenuButton = props => {
  const location = useLocation();

  const [selected, setSelected] = useState(false);

  const handleClick = e => {
    if (false) {
      e.preventDefault();
      alert(NO_INTEGRATOR_MESSAGE);
    }
  };

  return (
    <div className={'menu-button'}>
      <NavLink
        onClick={handleClick}
        to={props.path}
        className={({ isActive }) => {
          setSelected(isActive);
          return isActive ? ' menu-button-active' : '';
        }}
      >
        <i className={`${props.iconclassName}`}></i>
        <label>{props.title}</label>
      </NavLink>
      <div
        className={selected ? 'tab-selected-icon' : 'tab-selected-icon hidden'}
      ></div>
    </div>
  );
};
export default MenuButton;
